// Gravity Forms re-renders this module's form from scratch on every
// submission — both the very first server-rendered page load, and every
// AJAX (hidden-iframe) postback after that swaps in fresh markup — so
// there's no single "page load" moment to rely on. Whenever a field comes
// back with an error, this copies that error's message text directly into
// the field's own `<label>`/`<legend>` (as a `.gform-field-label__error`
// span) so it reads as part of the label instead of GF's own separate
// `.gfield_validation_message` box, which `_form-split.scss` hides for
// these field types once this span is present.
const FormSplit = {
  SCOPE_SELECTOR: '.module--form-split',
  ERROR_SPAN_CLASS: 'gform-field-label__error',
  LABELABLE_TYPE_CLASSES: [
    'gfield--type-text',
    'gfield--type-email',
    'gfield--type-phone',
    'gfield--type-number',
    'gfield--type-website',
  ],

  injectInlineErrors: function () {
    const errorFields = document.querySelectorAll(`${this.SCOPE_SELECTOR} .gfield_error`);

    errorFields.forEach((field) => {
      const isLabelable = this.LABELABLE_TYPE_CLASSES.some((className) => field.classList.contains(className));
      if (!isLabelable) return;

      const label = field.querySelector('.gfield_label, .gform-field-label');
      const message = field.querySelector('.gfield_validation_message, .validation_message');
      if (!label || !message) return;

      const messageText = message.textContent.trim();
      if (!messageText) return;

      let errorSpan = label.querySelector(`.${this.ERROR_SPAN_CLASS}`);
      if (!errorSpan) {
        errorSpan = document.createElement('span');
        errorSpan.className = this.ERROR_SPAN_CLASS;
        errorSpan.setAttribute('aria-hidden', 'true');
        label.appendChild(errorSpan);
      }

      // Guards the MutationObserver above from re-triggering itself
      // forever off of this same write.
      if (errorSpan.textContent !== messageText) {
        errorSpan.textContent = messageText;
      }
    });
  },

  init: function () {
    const self = this;

    self.injectInlineErrors();

    // Fired by Gravity Forms' own inline script right after it swaps the
    // ajax iframe's response into `#gform_wrapper_{id}` — covers both a
    // failed submission re-showing this same page and a valid one moving
    // to a different page of a multi-page form. Kept as a fast path, but
    // not relied on alone (see the MutationObserver below) since Gravity
    // Forms has more than one internal render/event system depending on
    // version/config and this page's exact one wasn't easy to pin down.
    $(document).on('gform_page_loaded gform_confirmation_loaded', () => {
      self.injectInlineErrors();
    });

    // Belt-and-suspenders: watch the wrapper Gravity Forms swaps content
    // into directly, so this reacts to the DOM actually changing rather
    // than depending on which particular event (if any) fires for it.
    // `injectInlineErrors()` is a no-op once a field's error span already
    // has the right text, so this can't loop forever off its own edits.
    document.querySelectorAll(`${self.SCOPE_SELECTOR} .gform_wrapper`).forEach((wrapper) => {
      new MutationObserver(() => self.injectInlineErrors()).observe(wrapper, {
        childList: true,
        subtree: true,
      });
    });
  },
};

export default FormSplit;
